import { WishlistEntry } from '@models/IWishlistCardSwitch';
import { IColourId, IColours, IHotspot } from '@models/IWishlistData';
import CardTypeEnum from '@models/enums/CardTypeEnum';

export const mapWishlistData = ({
  collection,
  data,
  fields,
  newModel,
}: WishlistEntry['entity']) => {
  if (newModel) return data;

  switch (collection) {
    case CardTypeEnum.Colours:
      return {
        colourHexCode: data.colourHex,
        colourCode: data.colourCode,
        colourName: data.colourName,
        images: [],
        link: data.linkUrl,
        variant: null,
        bgColour: null,
      };

    case CardTypeEnum.Products:
      return {
        cta: {
          text: 'view more',
          url: data.linkUrl,
        },
        images: [],
        productImage: {
          mobile: {
            url: data.mobileImage ? data.mobileImage : '/',
            originalHeight: 0,
            originalWidth: 0,
            altText: 'product image',
          },
          desktop: {
            url: data.desktopImage ? data.desktopImage : '/',
            originalHeight: 0,
            originalWidth: 0,
            altText: 'product image',
          },
        },
        productName: data.name,
        productRole: data.cardDescription,
        category: data.type,
        usps: data.usps,
      };

    case CardTypeEnum.Inspirations:
      const source = data || fields;

      const colourMap = new Map(
        source?.colours?.map((colour: IColours) => [
          colour.jotunId,
          {
            name: colour.name,
            hexCode: colour.hexValue,
            url: '/',
            colourCode: colour.stdNumber,
          },
        ]),
      );

      const hotspots = source?.hotspots?.value.map(
        ({
          featured_colour,
          featured_products,
          mobile_coordinates,
          desktop_coordinates,
        }: IHotspot) => {
          const featuredColour = featured_colour?.value;
          const colourId = colourMap.get(
            featuredColour?.componentMeta?.fields?.colourId?.value,
          ) as IColourId;

          const mobileImageUrl =
            featuredColour?.fields.image?.value?.fields.mobile_image?.value;
          const desktopImageUrl =
            featuredColour?.fields.image?.value?.fields.desktop_image?.value;

          return {
            horizontalPercentMobile: mobile_coordinates.value.fields.left.value,
            verticalPercentMobile: mobile_coordinates.value.fields.top.value,
            horizontalPercentDesktop:
              desktop_coordinates.value.fields.left.value,
            verticalPercentDesktop: desktop_coordinates.value.fields.top.value,
            product: {
              name: featured_products?.value[0]?.fields.name.value,
              url: featured_products?.value[0]?.linkUrl,
            },
            colour: {
              name: featuredColour?.fields.name.value,
              hexCode: colourId?.hexCode ?? null,
              previewUrl: mobileImageUrl ?? desktopImageUrl,
              url: featuredColour?.linkUrl,
              colourCode:
                colourId?.colourCode ??
                featuredColour?.fields.specialColourNumber?.value,
            },
          };
        },
      );

      return {
        link: source?.linkUrl,
        desktopImage: {
          url:
            source?.desktopImage ||
            source?.image?.value?.fields.desktop_image?.value,
          originalHeight: 0,
          originalWidth: 0,
          altText: 'inspiration image',
        },
        mobileImage: {
          url:
            source?.mobileImage ||
            source?.image?.value?.fields.mobile_image?.value,
          originalHeight: 0,
          originalWidth: 0,
          altText: 'inspiration image',
        },
        video: null,
        hotspots: hotspots ?? [],
      };

    default:
      return null;
  }
};
